import { parseHTML } from '../../utils/dom'
import BaseComponent from '../base-component/base-component'
import { bodyElement } from '../common/body-element'
import { hideElement, showElement } from '../../utils/dom'

class CartRelatedProducts extends BaseComponent {
  lastRequestedUrl: string

  connectedCallback(): void {
    this.loadProducts()
  }

  erase(): void {
    this.replaceChildren()

    this.setReady(false)
  }

  loadProducts(): void {
    if (this.lastRequestedUrl === this.dataset.url) {
      return
    }

    this.lastRequestedUrl = this.dataset.url

    if (!this.dataset.url) {
      return
    }

    this.showPreloader()

    return fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        this.hidePreloader()

        const html = parseHTML(text)

        this.updateByHTML(html)
      })
      .catch(() => {
        if (!bodyElement.notification) {
          return
        }

        bodyElement.notification.show(
          'Error in cart related products',
          'warning',
        )
      })
  }

  updateByHTML = (node: HTMLElement): void => {
    const recommendations = node.querySelector(`#${this.id}`)

    if (recommendations) {
      const clonedRecommendations = recommendations.cloneNode(true)

      this.replaceChildren(...clonedRecommendations.childNodes)
    }

    const products = this.querySelectorAll('vertical-product-card')

    this.setReady(products.length > 0)
  }

  setReady(isReady: boolean): void {
    this.toggleAttribute('is-ready', isReady)
  }

  showPreloader(): void {
    const loadingOverlay = this.querySelector('.loading-overlay')

    showElement(loadingOverlay)
  }

  hidePreloader(): void {
    const loadingOverlay = this.querySelector('.loading-overlay')

    hideElement(loadingOverlay)
  }
}

export default CartRelatedProducts
